import { useState } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Hook personalizado para manejar el estado del Header
 * Centraliza la lógica de dropdowns y menú móvil
 */
export const useHeaderState = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownStates, setDropdownStates] = useState({
    experiencias: false,
    general: null,
  });
  const navigate = useNavigate();

  const toggleDropdown = (dropdownName, index = null) => {
    if (dropdownName === "general") {
      setDropdownStates((prev) => ({
        ...prev,
        general: prev.general === index ? null : index,
        experiencias: false,
      }));
    } else {
      setDropdownStates((prev) => ({
        ...prev,
        [dropdownName]: !prev[dropdownName],
        general: null,
      }));
    }
  };

  const closeAllDropdowns = () => {
    setDropdownStates({
      experiencias: false,
      general: null,
    });
  };

  const handleExperienciasItemClick = (item) => {
    if (item.href) {
      navigate(item.href);
    }
    closeAllDropdowns();
  };

  return {
    mobileMenuOpen,
    setMobileMenuOpen,
    dropdownStates,
    toggleDropdown,
    closeAllDropdowns,
    handleExperienciasItemClick,
  };
};
